module.exports = __webpack_public_path__ + "img/wordpress-woocommerce.d2061aab.png";